<template>
  <v-select
    v-model="componenteTipoIdLocale"
    dense
    outlined
    validate-on-blur
    item-text="nome"
    item-value="id"
    label="Tipo de componente:"
    :loading="isGetTiposDeComponentesLoading"
    :filled="!isComponenteNovo"
    :disabled="!isComponenteNovo"
    :items="tiposDeComponentesLocale.todos"
    :append-icon="icons.mdiShape"
    :rules="[validators.select]"
    @change="updateComponenteTipoId"
  />
</template>

<script>
import { mdiShape } from '@mdi/js'
import { ref, onMounted, watchEffect } from '@vue/composition-api'
import { select } from '@core/utils/validation'
import FormularioService from '@/services/modules/FormularioService'
import TiposDeComponentesEnum from '@/models/entities/formulario/componente/TiposDeComponentesEnum'

export default {
  props: {
    componenteTipoId: {
      type: Number,
      required: true,
    },
    isComponenteNovo: {
      type: Boolean,
      required: true,
    },
    tiposDeComponentes: {
      type: Object,
      required: true,
    },
    filtrarComponentesQuenNaoPodemSerEnviadosPorChatBot: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const tiposDeComponentesLocale = ref({ todos: [], encadeaveis: [] })
    const isGetTiposDeComponentesLoading = ref(false)
    const componenteTipoIdLocale = ref(0)
    const filtrarComponentesQuenNaoPodemSerEnviadosPorChatBotLocale = ref(false)

    async function getTiposDeComponentes() {
      try {
        isGetTiposDeComponentesLoading.value = true
        tiposDeComponentesLocale.value.todos = await FormularioService.getTiposDeComponentes()

        tiposDeComponentesLocale.value.encadeaveis = tiposDeComponentesLocale.value.todos.filter(it => it.encadeavel)

        if (filtrarComponentesQuenNaoPodemSerEnviadosPorChatBotLocale.value) {
          tiposDeComponentesLocale.value.todos = tiposDeComponentesLocale.value.todos.filter(el => el.id !== TiposDeComponentesEnum.BotaoEmail && el.id !== TiposDeComponentesEnum.Assinatura)
        }

        emit('update:tipos-de-componentes', tiposDeComponentesLocale.value)
      } finally {
        isGetTiposDeComponentesLoading.value = false
      }
    }

    watchEffect(async () => {
      filtrarComponentesQuenNaoPodemSerEnviadosPorChatBotLocale.value = props.filtrarComponentesQuenNaoPodemSerEnviadosPorChatBot
      componenteTipoIdLocale.value = props.componenteTipoId
      await getTiposDeComponentes()
    })

    onMounted(async () => { await getTiposDeComponentes() })

    function updateComponenteTipoId(val) { emit('update:componente-tipo-id', val) }

    return {
      tiposDeComponentesLocale,
      isGetTiposDeComponentesLoading,
      componenteTipoIdLocale,
      updateComponenteTipoId,
      icons: {
        mdiShape,
      },
      validators: {
        select,
      },
    }
  },
}
</script>
